import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { TIKTOK_PIXEL_ID, loadTikTokPixel, ttPageView } from '@/lib/tiktokPixel';

/**
 * Loads the TikTok Pixel (idle/first-interaction, so it never blocks LCP)
 * and fires a PageView on every route change.
 */
const TikTokPixel = () => {
  const location = useLocation();

  useEffect(() => {
    if (!TIKTOK_PIXEL_ID) return;
    const timer = window.setTimeout(loadTikTokPixel, 2500);
    const load = () => {
      window.clearTimeout(timer);
      loadTikTokPixel();
    };
    const events: (keyof DocumentEventMap)[] = ['click', 'scroll', 'keydown', 'touchstart'];
    events.forEach((e) => document.addEventListener(e, load, { once: true, passive: true }));
    return () => {
      window.clearTimeout(timer);
      events.forEach((e) => document.removeEventListener(e, load));
    };
  }, []);

  useEffect(() => {
    ttPageView();
  }, [location.pathname]);

  return null;
};

export default TikTokPixel;
